export enum WorkspaceGroupErrorCode {
  USER_ALREADY_IN_GROUP,
  USER_NOT_IN_GROUP,
}
